import { jsx as s } from "react/jsx-runtime";
import { c as d } from "../../../index-Cu0xwYjD.js";
import '../../../assets/Display.css';const p = "_heading_vgmxw_4", v = "_surface_vgmxw_10", f = "_inverted_vgmxw_14", a = {
  heading: p,
  surface: v,
  inverted: f
}, n = ({
  children: e,
  className: i,
  inverted: r,
  level: t,
  semanticComponent: c = "p",
  variant: o = "brand",
  ...l
}) => /* @__PURE__ */ s(c, { ...l, children: /* @__PURE__ */ s(
  "span",
  {
    className: d(
      a.heading,
      {
        [a.inverted]: r,
        [a.surface]: o === "surface"
      },
      i
    ),
    style: {
      fontSize: `var(--font-size-d${t})`,
      letterSpacing: `var(--font-letter-spacing-d${t})`,
      lineHeight: `var(--font-line-height-d${t})`
    },
    children: e
  }
) }), _ = ({
  ...e
}) => /* @__PURE__ */ s(n, { ...e, level: "1" }), h = (e) => /* @__PURE__ */ s(n, { ...e, level: "2" }), y = (e) => /* @__PURE__ */ s(n, { ...e, level: "3" }), u = (e) => /* @__PURE__ */ s(n, { ...e, level: "4" });
export {
  n as Display,
  _ as Display1,
  h as Display2,
  y as Display3,
  u as Display4
};
